<section class="quotes-panel" role="tabpanel">
  @if (loading()) {
    <div class="quotes-panel__state">
      <app-cog-loading-spinner [size]="64" />
      <span>Carregando as cotações...</span>
    </div>
  } @else if (error()) {
    <div class="quotes-panel__state quotes-panel__state--error" role="alert">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <strong>{{ error() }}</strong>
      <app-button
        [label]="'Tentar de novo'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="load()" />
    </div>
  } @else if (!loans().length) {
    <div class="quotes-panel__state">
      <i class="pi pi-money-bill" aria-hidden="true"></i>
      <strong>Esta empresa ainda não possui empréstimos cotados.</strong>
      <span>
        Os empréstimos da empresa com status Cotado aparecem aqui assim que forem cadastrados na
        Gestão de Empréstimos.
      </span>
    </div>
  } @else {
    <div class="quotes-panel__card">
      <header class="quotes-panel__head">
        <h3 class="quotes-panel__title">Empréstimos cotados</h3>
        <span class="quotes-panel__count">{{ loans().length }}</span>
      </header>

      <div class="quotes-panel__scroll">
        <table class="quotes-table">
          <thead>
            <tr>
              <th>Banco</th>
              <th>Modalidade</th>
              <th class="quotes-table__num">Valor</th>
              <th class="quotes-table__num">Valor (BRL)</th>
              <th class="quotes-table__num">Taxa de juros a.a.</th>
              <th class="quotes-table__num">Custo all-in a.a.</th>
              <th>Data da operação</th>
            </tr>
          </thead>
          <tbody>
            @for (loan of loans(); track loan.id) {
              <tr>
                <td>
                  <!-- O banco é o link (card 3611): abre a modal do empréstimo aqui mesmo, em só leitura para
                       o parceiro. Só com LoanOperation.VIEW, que a modal exige; sem ela, o banco é texto. -->
                  @if (canOpenLoan()) {
                    <button
                      type="button"
                      class="quotes-table__bank quotes-table__link"
                      [title]="
                        readOnlyLoan()
                          ? 'Ver os detalhes do empréstimo (só leitura)'
                          : 'Abrir os detalhes do empréstimo'
                      "
                      (click)="openLoan(loan)">
                      <ng-container *ngTemplateOutlet="bankLabel; context: { $implicit: loan }" />
                    </button>
                  } @else {
                    <span class="quotes-table__bank">
                      <ng-container *ngTemplateOutlet="bankLabel; context: { $implicit: loan }" />
                    </span>
                  }
                </td>
                <td>{{ typeLabel(loan.loanOperationType) }}</td>
                <td class="quotes-table__num">
                  {{ loan.value | vaultFormatCurrency: 2 : loan.currencyCode ?? '' }}
                </td>
                <td class="quotes-table__num">
                  {{
                    loan.valueLocalCurrency !== null
                      ? (loan.valueLocalCurrency | vaultFormatCurrency: 2 : 'R$')
                      : '–'
                  }}
                </td>
                <td class="quotes-table__num">{{ loan.interestRate | vaultFormatPercent: 4 }}</td>
                <td class="quotes-table__num">
                  {{ loan.allInCost !== null ? (loan.allInCost | vaultFormatPercent: 4) : '–' }}
                </td>
                <td>{{ loan.operationDate | vaultDate }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }
</section>

<!-- Mesma modal da Gestão de Empréstimos; o parceiro abre em só leitura. -->
<!-- Nome do banco com o logo; sem banco, "Ver empréstimo" (no texto, só faz sentido como link). -->
<ng-template #bankLabel let-loan>
  @if (loan.bankName) {
    @if (loan.bankCompensationCode) {
      <app-bank-logo [code]="loan.bankCompensationCode" [maxWidth]="18" />
    }
    {{ loan.bankName }}
  } @else {
    {{ canOpenLoan() ? 'Ver empréstimo' : '–' }}
  }
</ng-template>

<app-modal-loan-details [readOnly]="readOnlyLoan()"></app-modal-loan-details>
